import React, { useEffect, useRef, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// import ReactPasswordToggleIcon from "react-password-toggle-icon";
import { loginlogo } from "../../imagepath";
import { Link, useHistory } from "react-router-dom";
import { loginapi } from "../../HttpRequest/beforelogin";
import { emailerror } from "../Base UI Elements/Toast";
import { useForm } from "react-hook-form";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useAuth } from "../../../AuthContext";
import "./normal.css";
import "./glass-login.css";

const Login = () => {
  const { login } = useAuth();
  const [disable, setDisable] = useState(true);
  const { handleSubmit, formState, register } = useForm();
  const [loading, setLoading] = useState(false);
  // const [password, setPassword] = useState("");
  useEffect(() => {
    formState.isValid ? setDisable(false) : setDisable(true);
  }, [formState.isValid]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await loginapi(data);
      const id = response.data.id;
      const orgId = response.data.orgId;
      const orgName = response.data.orgName;

      // Clean up legacy localStorage keys
      localStorage.removeItem("id");
      localStorage.removeItem("userRole");
      localStorage.removeItem("role");
      localStorage.removeItem("orgId");
      localStorage.removeItem("orgName");
      localStorage.removeItem("authenticated");

      // Save exclusively to sessionStorage
      sessionStorage.setItem("id", id);
      if (orgId) {
        sessionStorage.setItem("orgId", orgId);
      }
      if (orgName) {
        sessionStorage.setItem("orgName", orgName);
      }

      let role = response.data.roles[0];
      if (role) {
        if (role.startsWith("ROLE_")) {
          role = role.replace("ROLE_", "").toLowerCase().replace("_", "-");
        } else {
          role = role.toLowerCase().replace("_", "-");
        }
      }
      sessionStorage.setItem("userRole", role);
      sessionStorage.setItem("role", role);
      sessionStorage.setItem("authenticated", "true");
      if (role == "user") {
        history.push("/dashboard");
      } else if (role == "admin") {
        history.push("/admindashboard");
      } else if (role == "application-assistant") {
        history.push("/teamdashboard");
      } else {
        history.push("/superadmin");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        emailerror(error.response.data.message);
        console.error("Error during log:", error.response.data.message);
      } else {
        emailerror(error.message);
        console.error("Error during log:", error.message);
      }
      emailerror("Bad credentials");
      console.log("Bad credentials");
    } finally {
      setLoading(false);
    }
  };

  const history = useHistory();
  let inputRef = useRef();
  const showIcon = () => (
    <i className="feather feather-eye" aria-hidden="true">
      <FeatherIcon icon="eye" />
    </i>
  );
  const hideIcon = () => (
    <i className="feather feather-eye-slash" aria-hidden="true">
      <FeatherIcon icon="eye-off" />
    </i>
  );

  const eyeFunction = () => {
    var x = document.getElementById("userpassword");
    let icon1 = document.querySelector(".fa-eye");
    if (x.type === "password") {
      x.type = "text";
      icon1.classList.toggle("fa-eye-slash");
    } else {
      x.type = "password";
      icon1.classList.toggle("fa-eye-slash");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="main-wrapper login-body">
          <div className="login-wrapper">
            <div className="container">
              <div className="loginbox">
                <div className="login-left">
                  <img className="img-fluid" src={loginlogo} alt="Logo" />
                </div>
                <div className="login-right">
                  <div className="login-right-wrap">
                    <h1>Welcome to Overseas Education Platform</h1>

                    <p className="account-subtitle">
                      Need an account? <Link to="/register">Sign Up</Link>
                    </p>
                    <h2>Sign in</h2>

                    <div className="form-group">
                      <label htmlFor="userloginusername">
                        Email <span className="login-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        {...register("phoneNumberOrEmail", {
                          required: {
                            value: true,
                          },
                        })}
                        name="phoneNumberOrEmail"
                        id="phoneNumberOrEmail"
                      />
                      <span className="profile-views">
                        <i className="fas fa-user-circle" />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="userpassword">
                        Password <span className="login-danger">*</span>
                      </label>
                      <input
                        style={{ inputSecurity: "none" }}
                        ref={inputRef}
                        className="form-control pass-input"
                        type="password"
                        name="password"
                        id="userpassword"
                        {...register("password", {
                          required: {
                            value: true,
                          },
                        })}
                      />
                      <div onClick={eyeFunction} className="eyeIcon">
                        <i
                          className="fas fa-eye"
                          aria-hidden="true"
                          id="eyeicon"
                        ></i>
                      </div>
                    </div>
                    <div className="forgotpass justify-content-end">
                      <Link to="/forgotpassword">Forgot Password?</Link>
                    </div>
                    <div className="form-group">
                      <button
                        className={`btn btn-primary btn-block ${
                          loading ? "loading" : ""
                        }`}
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          "Login"
                        )}
                      </button>
                    </div>

                    <div className="login-or">
                      <span className="or-line" />
                      <span className="span-or">or</span>
                    </div>

                    <div className="social-login">
                      <Link to="#">
                        <i className="fab fa-google" />
                      </Link>
                      <Link to="/whatapplogin">
                        <i className="fab fa-whatsapp" />{" "}
                      </Link>
                      <Link onClick={() => {}} to="#">
                        <i className="fab fa-facebook-f" />
                      </Link>
                      <Link to="#">
                        <i className="fab fa-twitter" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Login;
